<template>
  <div class="process-content protocol-editor">
    <ProcessTop></ProcessTop>
    <!-- 실험타입(기본값SET) 패널 제거 (2026-06 리뉴얼: 프로토콜 에디터에서는 미사용) -->
    <article class="protocolControl">
      <div class="tabWrap" :class="{ wikiActive: typeChecked === 'wiki' }">
        <!-- &&  -->
        <template v-if="!initChecked && !emptyProtocol" v-for="{ label , type } in tabInfo">
          <label v-if="type === 'tree' || type === 'wiki' && PROCESS_INFO.protocols && PROCESS_INFO.protocols.length !== 0 ">
            <input type="radio" :id="type" v-model="typeChecked" :value="type" name="protocolTab">
            <span :for="type">{{ label }}</span>
          </label>
        </template>
        <!-- <Options :diagram="editorInfo.diagram" v-if="typeChecked == 'tree'"></Options> -->
      </div>

      <DocumentOption v-if="!manageMode" apiType="protocol"></DocumentOption>
      <ProtocolReadOnlyDocumentOption
          v-if="manageMode"
          :isAuth="isAuth"
          apiType="protocol"
          :protocolType="protocolType"
      />

      <Editor 
            v-if="typeChecked == 'tree'"
            :treeMode="treeMode"
            @updateNode="updateList"
            @change="(mode)=>modeChange(mode)"
            @mount="(info)=>{editorInfo=info}"
            :firstBln="firstBln"
            @linkNodeSetCheck="(data)=>this.PublishPopupObj.nodeSetComplete = data"
            :key="componentKey"
            @forceRerender = "forceRerender"
            ref="editor"
            :editKey="editKey"
      ></Editor>
      <Wiki v-if="typeChecked == 'wiki'" :readonly="treeMode==='readonly'" @change="typeChecked='tree'"></Wiki>
       <Loading :visible="loading" /> 

      <editor-btm-option
        class="protocolBtmBar"
        v-if="!initChecked && !emptyProtocol && treeMode != 'readonly' && !manageMode"
        :openLogListPopup="openLogListPopup" 
        :openSaveLogPopup="openSaveLogPopup" 
        :openPublishPopup="openPublishPopup"
        :protocolType="protocolType"
        @searchProcessNode="searchProcessNode"
        @endEditProtocol="endEditProtocol"
        @saveRequest="saveDiagram"
      />

      <ProtocolReadOnlyBtmOption
          v-if="manageMode"
          :class="{ protocolReadBar: isAuth }"
          :isAuth ="isAuth"
          :connectProtocolData = "connectProtocolData"
          :openUtilizeListPopup="openUtilizeListPopup"
          @editOriginProtocol="setEditFlag"
          :protocolType="protocolType"
      />

      <!-- START 공정도 붙이기 ===============================================================  -->
    <ProcessPreview
      @setMethod="getChildMethods('preview', $event)"
      :process-info="selectProcessInfo"
      @preview-close="searchPopupShow"
    />
    <ProcessNodeSearch :type="'process'"
      @setMethod="getChildMethods('search', $event)"
      @select-process="selectProcess"
      @process-preview="previewClick"
    />
    <!-- END 공정도 붙이기 ===============================================================  -->

    </article>
    <div class="wikiViewerPopup" v-if="status.wikiPreviewerStatus.visible">
      <div class="layerWrap">
        <h2>위키 미리보기</h2>
        <WikiViewer :Data="status.wikiPreviewerStatus"></WikiViewer>
        <button class="close" @click="status.wikiPreviewerStatus = false">닫기</button>
      </div>
		</div>
    <SaveLogPopup :crntObj="SaveLogPopupObj" />
    <LogListPopup :crntObj="LogListPopupObj" />
    <releasePopup :openFlag.sync="PublishPopupObj.openBln" @saveDiagram="saveDiagram"/>
<!--    <SaveLogPopup :crntObj="PublishPopupObj" />-->
    <UtilizeListPopup :crntObj="UtilizeListPopupObj" />
  </div>
  </template>
  
  <script>
  import ProcessTop from '../processEditor/Top.vue'; 
  // import Editor from './tree.vue' ;
  import Editor from './treeNew.vue' ;
  import Loading from '../common/loading.vue'
  import CommNew, {commNewMapMutations, commNewMapGetters} from "@processEditor/CommNew";
  import Wiki from './wiki.vue'
  // import ListItemWrap from './ListItemWrap' ; 
  import IssueList from './IssueList';
  import DocumentOption from "@nav_process/Editor/documentOption"
  import Options from '@components/nav_process/Editor/options';
  import { v4 } from "uuid";
  // import BtmComp from "@components/protocolEditor/BtmComp";
  import releasePopup from '@nav_process/Editor/comp/releasePopup' ;
  import SaveLogPopup from '@nav_process/Editor/comp/SaveLogPopup' ;
  import LogListPopup from '@nav_process/Editor/comp/LogListPopup' ; 
  import flattenObject from "@/plugins/flattenObject";
  import EditorBtmOption from '@common/EditorBtmOption' ;
  import ProtocolReadOnlyBtmOption from '@common/ProtocolReadOnlyBtmOption' ;
  import ProtocolReadOnlyDocumentOption from "@nav_process/Editor/ReadOnlyDocumentOption"
  import WikiViewer from '@components/platform_new/wikiViewer.vue';
  import UtilizeListPopup from "@/components/protocolEditor/comp/UtilizeListPopup";
  import ProcessNodeSearch from '../common/ProcessNodeSearch.vue'
  import ProcessPreview from '../processEditor/processPreview.vue'

  export default {
    mixins: [CommNew],
    components: {
      ProcessTop, 
      Editor, 
      Wiki, 
      Loading, 
      // ListItemWrap, 
      IssueList,
      DocumentOption, 
      Options, 
      // BtmComp , 
      SaveLogPopup , 
      LogListPopup , 
      EditorBtmOption , 
      WikiViewer ,
      ProtocolReadOnlyDocumentOption,
      ProtocolReadOnlyBtmOption,
      releasePopup,
      UtilizeListPopup,
      ProcessNodeSearch,
      ProcessPreview
    },
    data () {
      // const firstChked = 'tree' ; 
      // const firstChked = 'wiki' ; 
      return {
        componentKey : 0,
        loading : false,
        treeMode : "readonly",
        initChecked : false, //프로토콜 트리의 템플릿 초기 셋팅여부 확인
        emptyProtocol : false, //비어있는 프로토콜 여부

        onlyOneIdx : null , 
        onlyOneBln : false , 
        firstBln : true , 
        processTitle : '' , 
        tabInfo : [
          {
            type : 'tree' , 
            label : '트리형식보기' , 
          } , 
          {
            type : 'wiki' , 
            label : '위키형식보기' , 
          } , 
        ] , 
        typeChecked : '' , 
  
        crntProtocol : null , 
        processInfo: {},
        protocolData: {} , 
  
        protocolItems : [] , 
        itemList : [] , 
        editorInfo: {} , 

        SaveLogPopupObj : {
          openBln : false , 
          closeHandler : _=> this.SaveLogPopupObj.openBln = false , 
        } , 
        PublishPopupObj : {
          openBln : false , 
          publishType : true,
          processType : null,
          crntProtocol : null,
          nodeSetComplete : null,
          closeHandler : _=> this.PublishPopupObj.openBln = false , 
        } ,           
        LogListPopupObj : {
          openBln : false , 
          closeHandler : _=> this.LogListPopupObj.openBln = false , 
        } ,
        UtilizeListPopupObj : {
          openBln : false ,
          closeHandler : _=> this.UtilizeListPopupObj.openBln = false ,
        } ,
        manageMode : false,
        connectProtocolData : null,
        protocolType : "",
        isAuth : false,
        searchPrcessMethods : {},
        searchPrcessPreviewMethods : {},
        selectProcessInfo: {},
        editKey: null,
      }
    },
  
    computed : {
      issueList () {
        if ( 
          this.protocolIssueList.length != 0 && 
          this.$route.query.onlyOne 
        ) {

          let findNum = null ; 
          this.protocolIssueList.map(( issue , idx ) => {
            const rslt = flattenObject( issue ) ; 
            const rsltValues = Object.values( rslt ) ; 
            rsltValues.map( v => {
              if ( v == this.$route.query.keyOfProtocol ) {
                findNum = idx ; 
                return ; 
              }
            }) ; 
          }) ; 

          this.onlyOneIdx = findNum ; 
          // console.log( 'this.onlyOneIdx : ' , this.onlyOneIdx ) ; 
        }

        return this.protocolIssueList ; 
      } , 
    } , 
    watch : {
      typeChecked ( chked ) {
        console.log( "check", chked )
        let { protocolId } = this.$route.query ; 
        this.setProtocolId( protocolId ) ;
        // this.updateStatus({protocolTabType: chked})
        //this.checkUser(true) ;
      } , 

      treeMode( mode ){
        this.initStateCheck();
        this.emitWorkspaceMode();
      },
      manageMode(){
        this.emitWorkspaceMode();
      },
      isAuth(){
        this.emitWorkspaceMode();
      },
      'PROCESS_INFO.protocols' : {
        async handler ( protocols ) {
          this.checkUser(false) ; 
          if ( !protocols ) return ; 
          if ( protocols.length == 0 ) return ; 
          if ( this.firstBln ) return ; // 최초 로딩시는 접근 불가 
          // await this.itemsSet() ; 
          // await this.itemsListSet() ; 
        } , 
      } , 
      'status.protocolTabType'(value) {
        console.log("Tab change watch : ", value);
        this.typeChecked = value;
      },
      '$route.query.protocolId' : {
        async handler () {
          this.manageMode = true;
          this.initStateCheck();
          this.checkUser(true) ; 
        } , 
      } , 
      '$route.query.workspaceAction' ( action ) {
        this.runWorkspaceAction( action ) ;
      },
      
    } , 
    async mounted () {
      this.loading = true;
      this.updateStatus({ issueListViewBln : false }) ;
      if( this.$route.query.processId == "NaN" ){
        this.$router.push({ path : `/protocol/gate` }) ; 
        return;
        this.loading = false;
      }

      let { user , $route : { query }} = this ;
      this.setInitInfo({ user , query }) ; 
      const protocols = await this.getProtocols();
      const processDetail = await this.$wApi.process.detail(null, query.processId ) ; 
      const { json } = processDetail ; 
      const { links , nodes } = await this.converStringToJSON( json ) ;
      this.setPROCESS_INFO({ protocols , links , nodes }) ;
      this.updateProcessInfo({
        processId:processDetail.processId,
        fieldId:processDetail.fieldId,
        fieldName:processDetail.fieldName,
        processName:processDetail.processName,
        processType:processDetail.processType,
        processCollaborators : processDetail.collaborators,
        processAuthorUser : processDetail.user,
      })
      this.firstBln = true ; 
      // await this.itemsSet() ; 
      // await this.itemsListSet() ; 

      // console.log( "protocols", protocols );
      this.initStateCheck();

      setTimeout(_=>{
        this.firstBln = false ; 
        // this.typeChecked = this.status.protocolTabType;
        // 위키상태에서 신규 생성 시 위키로 넘어가는걸 막음
      } , 1000 )

      // console.log({ PROCESS_INFO : this })
      const { processName } = await this.$wApi.process.detail(null, this.$route.query.processId ) ; 
      this.processTitle = processName ; 

      console.log('Test : ', this.status.protocolTabType)
      this.typeChecked =  this.status.protocolTabType || 'tree'
      this.loading = false;
      this.runWorkspaceAction( this.$route.query.workspaceAction ) ;
      this.emitWorkspaceMode() ;
    } ,
    beforeDestroy () {
      // 에디터 이탈 시 사이드바 편집 메뉴 숨김
      this.$root.$emit( 'protocol-editor-mode' , null ) ;
    } ,
    methods: {
      ...commNewMapMutations(['updateStatus']),

      modeChange(data){
        this.treeMode = data.mode;
      },  
      forceRerender() {
        this.componentKey += 1;
      },
      openSaveLogPopup () {
        this.SaveLogPopupObj.openBln = true ; 
      } , 
      openLogListPopup () {
        this.LogListPopupObj.openBln = true ; 
      } , 
      openPublishPopup () {
        this.PublishPopupObj.processType = this.PROCESS_INFO.processType;
        const { protocols } = this.PROCESS_INFO ;
        const crntProtocol = protocols.filter(o=>o.id == this.$route.query.protocolId)[0];
        this.PublishPopupObj.crntProtocol = crntProtocol;
        this.PublishPopupObj.openBln = true ; 
      },

      openUtilizeListPopup() {
        this.UtilizeListPopupObj.openBln = true;
      },
      emitWorkspaceMode () {
        const mode = ( this.manageMode || this.treeMode === 'readonly' ) ? 'readonly' : 'edit' ;
        this.$root.$emit( 'protocol-editor-mode' , {
          mode ,
          isAuth : this.isAuth ,
          protocolType : this.protocolType ,
        }) ;
      },

      runWorkspaceAction ( action ) {
        if ( !action ) return ;
        this.$nextTick(() => {
          if ( action === 'connect' && this.searchPrcessMethods.show ) {
            this.searchProcessNode() ;
          }
          if ( action === 'publish' ) {
            this.openPublishPopup() ;
          }
          if ( action === 'save' ) {
            this.saveDiagram() ;
          }
          if ( action === 'preview' ) {
            const { processId , protocolId } = this.$route.query ;
            this.updateStatus({ wikiPreviewerStatus : {
              visible : true ,
              processId : processId ,
              protocolId : protocolId ,
            }}) ;
          }
          if ( action === 'docOption' ) {
            this.updateStatus({ 'DocumentOption' : true }) ;
          }
          if ( action === 'readonly' ) {
            this.endEditProtocol() ;
          }
          /* 읽기모드 전용 액션 */
          if ( action === 'utilizeList' ) {
            this.openUtilizeListPopup() ;
          }
          if ( action === 'editMode' ) {
            this.setEditFlag() ;
          }
          if ( action === 'docInfo' ) {
            this.updateStatus({ 'readOnlyDocumentOption' : true }) ;
          }
        }) ;
      },

      linkgoToProcessHandler () {
        // console.log( 'linkgoToProcessHandler in' ) ; 
        
        this.$router.push({
          path: "/process/editor",
          query: {
            processId: this.processId,
            editorType: "process",
            protocolId: null,
          },
        });
      } , 
      async checkUser(changeModeFlag) {
        // 접속 한 유저와 공정도 제작자가 같은 지 확인
        // 다를 경우 읽기전용 페이지로 이동
        // let loginUser, documentUser;
        // loginUser = this.USER_INFO.name
        // if(!this.USER_INFO.userName) {
        //   let { 
        //     user : processUser 
        //   } = await this.$wApi.process.detail( null , this.$route.query.processId ) ;
        //   documentUser = processUser.userName;
        // } else {
        //   documentUser = this.USER_INFO.userName;
        // }
        //if(loginUser !== documentUser) {
        const { protocols } = this.PROCESS_INFO ;
        if(!protocols){ // protocols이 세팅 완료되지 않아 null일 경우 return.
          return;
        }

        const processDetail = await this.$wApi.process.detail(null, this.$route.query.processId ) ;
        if (processDetail?.error || processDetail == null) {
          window.alert("서버와 통신중 오류가 발생했습니다.<br>잠시후 다시 시도해 주세요.");
          return;
        }
        const processType = processDetail.processType;

        const crntProtocol = protocols.filter(o=>o.id == this.$route.query.protocolId)[0];
        // console.log( "crntProtocol", crntProtocol)
        if(this.$route.query.processId == 773 || this.$route.query.processId == 5){ 
          // 박수형 박사님 시연용 데이터 임시 readOnly 처리.
          crntProtocol.editerMode = false;
        }
        if (crntProtocol && crntProtocol.editerMode == false) {
          //프로토콜 수정권한 없을경우
          this.treeMode = 'readonly';
          this.manageMode = true;
          this.isAuth = false;
        } else {
          //프로토콜 신규생성 분리
          if (crntProtocol != undefined && crntProtocol != null) {
            try {
              if((!changeModeFlag && !this.manageMode && this.treeMode != "readonly") || this.$route.query.newFlag == 'Y'){
                //수정모드
                this.manageMode = false;
                if(this.treeMode == "readonly"){
                  this.treeMode = "normal";
                }else{
                  this.treeMode = changeModeFlag ? "normal" : this.treeMode;
                }
              }else{
                //관리모드
                this.isAuth = true;
                this.treeMode = 'readonly';
                this.manageMode = true;
              }
            }catch (error){
              //console.log(`${error} : copyright 로그에 참조되는 것이 없음`);
            }
          }
        }
        return true;
      },
      async setEditFlag() {
        try {
          const key = v4();
          let keyResponse;
          //console.log('this.editKey = {}',this.editKey)
          const response = await this.$wApi.simultaneous.editCheck({
            relativeId: this.$route.query.protocolId,
            editType: "PROTOCOL",
            validTime: Math.floor(this.editDuration / 1000),
          });
          if (response.isEditMode) {
            if (this.user.id == response.userResBody.id && response.editKey != null && response.editKey != "" && response.count == 0 && !response.editable) {
              //유저가 같음 && editStatus가 신규 상태가 아님 && 유효시간 지난 status가 없음(수정중! count=0) && editable == false => 어느 세션 유지할건지 confirm
              const confirmResult = await confirm("다른 브라우저에서 수정중입니다.<br/> 수정화면을 대체하시겠습니까?");
              if (confirmResult) {
                //key 발급(update).
                keyResponse = await this.$wApi.simultaneous.statusUpdate({
                  relativeId: this.$route.query.protocolId,
                  editType: "PROTOCOL",
                  editKey: key,
                  editable: false, //수정불가능상태로 변경
                });
              } else {
                //수정불가
                return;
              }
            } else {
              //수정가능 상태이거나 또는 유저가 다르거나 또는 editStatus가 신규 상태 또는 유효시간 지났을경우 => key 발급(update).
              keyResponse = await this.$wApi.simultaneous.statusUpdate({
                relativeId: this.$route.query.protocolId,
                editType: "PROTOCOL",
                editKey: key,
                editable: false, //수정불가능상태로 변경
              });
            }
            //수정가능
            if (!keyResponse.error) {
              this.editKey = key;
              this.manageMode = false;
              this.treeMode = "normal";
            }
          } else {
            //수정불가
            alert(`현재 ${response.userResBody.userName}님이 수정중입니다.`)
          }
        } catch (e) {
          console.log(e);
        }
      },
      async endEditProtocol(){
        //key update.
        const keyResponse = await this.$wApi.simultaneous.statusUpdate({
          relativeId: this.$route.query.protocolId,
          editType: "PROTOCOL",
          editable: true, //수정가능상태로 변경
        });
        await this.saveDiagram();
        this.$router.replace({
          path: '/protocol/editor',
          query: {
            processId: this.$route.query.processId,
            editorType: 'protocol',
            protocolId: this.$route.query.protocolId,
            keyOfProtocol: this.$route.query.keyOfProtocol,
          }
        });
        location.reload();
      },
      async itemsSet () {
        // console.log( '-- itemsSet in' ) ; 
        const { links , nodes , protocols } = this.PROCESS_INFO ; 
        /**
         * links 와 nodes 는  
         * 최소한 기본적으로 프로토콜일 경우 
         * link 1개와 nodes 2개가 생성되어야한다. 
         * 만약 없는경우라면 잘못된 데이터다.
         * */

        // console.log( 'Editor.vue -> itemsSet in' , {
          // links , 
          // nodes , 
        //   protocols , 
        // }) ; 

        for await ( const protocol of protocols ) {
          // !!!! 프로토콜의 json 값때문에 공정도 수정에 사용하는 json 텍스트가 너무 길어 에러가 날 수 있으나, 이 숫자표시때문에 json 을 사용해야함..
          // console.log({
          //   protocol , 
          //   json : protocol.json , 
          // }) ; 
          if ( !protocol.json ) return ; 
          this.setProtocolId( protocol.id ) ; 
          // protocol.json = await this.convertIssuesStringToJSON( protocol.json ) ; 
          protocol.json = typeof protocol.json == 'string' ? JSON.parse(protocol.json) : protocol.json;
          const link = links.find(( link , idx )=> { 
            if ( protocol.keyOfProtocol === link.from ) {
              // console.log( idx ) ; 
              return link ; 
            }
          }) ; 

          if ( !link ) break ; 

          const node = nodes.find( node => {
            if ( node.category === 'PROTOCOL' && String( node.key ) === String( link.to )) {
              return node ;
            }
          }) ; 

          if ( !node ) break ; 

          // if ( !node.protocol ) {
          //   node.protocol = [ protocol ] ; 
          // } else {
          //   if ( node.protocol.some( item => item.parent === protocol.keyOfProtocol ) ) break ; 
          //   node.protocol =  [...node.protocol , protocol ] ; 
          // }
        } // end of for await 

        this.protocolItems = {
          links , 
          nodes , 
          protocols , 
        } ; 
      } , // end of itemsSet 
      async itemsListSet () {
        const { processType , protocols : protocolsOrigin } = this.PROCESS_INFO ; 
        const { nodes , links } = this.protocolItems ; 
        const protocols = nodes.filter( item => item.hasProtocol ) ; 
        
        protocols.map( protocol => {
          protocol.detailInfo = protocolsOrigin.filter( protocolOrigin => {
            if ( protocolOrigin.keyOfProtocol == protocol.key ) {
              return protocolOrigin ; 
            }
          }) ; 
        }) ; 

        const itemsGetListNew = items => {
          let isLoop = true ; 
          const newItems = items.reduce(( arr , item ) => {
            const { text , key , category , children } = item ; 
            const currentLinks = links.filter( link => link.to === key ) ; 
            const parentNodes = currentLinks.map( item => nodes.find( node => node.key === item.from)) ; 

            if ( !parentNodes.length ) {
              const noData = {
                ANALYSIS    : '재료 없음' , 
                MEASUREMENT : '재료 없음' , 
                EQUIPMENT   : '측정/분석 목적 없음' , 
              } ; 
              const tempObj = noData[ category ] ? 
                {
                  text : noData[ category ] , 
                  category : 'NODATA' , 
                  key : v4() , 
                  children : [ item ] , 
                } : item 
              ; 
              arr = [ ...arr , tempObj ] ; 
              return arr ; 
            }

            if ( parentNodes.length ) {
              for ( let i = 0 ; i < parentNodes.length ; i += 1 ) {
                const parent = parentNodes[i] ; 
                const idx = arr.findIndex( item => {
                  if ( item.children[0].key === parent.key ) {
                    return item ; 
                  }
                }) ;
                // console.log('idx :' , idx ) ; 
                // parent.children = [ item ] ; 
                if ( idx < 0 ) {
                  arr.push({ ...parent , children : [ item ]}) ; 
                } else {
                  parent.children = [ item ] ; 
                }
                
              }
            }

            isLoop = false;
            return arr ; 
          } , []) ; 

          // console.log({ items }) ; 
          return isLoop ? newItems : itemsGetListNew( newItems ) ; 
        } ; 


        // const itemList = nodes && nodes.length ? this.itemsGetList( nodes , links , protocols ) : [] ; 
        const itemList = nodes && nodes.length ? itemsGetListNew( protocols ) : [] ; 
        this.itemList = itemList ; 
        // console.log( '------------------------------------------\n' , { itemList }) ; 
        // console.log({ itemList }) ; 
        this.updateState({ protocolIssueList : this.itemList }) ; 
      } , // end of itemsListSet 

      itemsGetList ( nodes , links , items , depth = 0 ) {
        let isLoop = true ; 

        const newItems = items.reduce(( arr , item ) => {
          const { key , category , children } = item ; 
          const currentLinks = links.filter( link => link.to === key ) ; 
          const parentNodes = currentLinks.map( item => nodes.find( node => node.key === item.from)) ; 

          const consoleChkFunc = _=> {
            console.table({
              parentNodes , 
              currentLinks , 
              key , 
              arr , 
              item , 
              category , 
            }) ; 
          } ; 

          if ( parentNodes && category == 'PROCESS' ) {
            console.log( ' -- category == PROCESS 진입' ) ; 
            // 공정이면 루프를 멈춘다. 
            // consoleChkFunc() ; 
            return [ ...arr , ...children ] ; 
          } // end of if ( parentNodes && item.category == 'PROCESS' )

          if ( !parentNodes.length ) {
            // console.log( ' -- 연결된 측정/분석 진입' ) ; 
            const noData = {
              ANALYSIS    : '재료 없음' , 
              MEASUREMENT : '재료 없음' , 
              EQUIPMENT   : '측정/분석 목적 없음' , 
            } ; 
            const tempObj = noData[ category ] ? 
              {
                text : noData[ category ] , 
                category : 'NODATA' , 
                key : v4() , 
                children : [ item ] , 
              } : item 
            ; 
            return [ ...arr , tempObj ] ; 
          }
          // end of if ( !parentNodes.length ) {
          isLoop = false;
          return arr;
        } , [] ) ; 
        return isLoop ? newItems : this.itemsGetList( nodes , links , newItems ) ; 
      } , 
      
      updateList(nodes) {
        const childCheck = (child, checkedKeyList) => {}
        this.protocolData = this.dataRefine(nodes)
      },
      dataRefine(datas) {
        const dataKeyMap = new Map()
        for(const data of datas) {
          if(dataKeyMap.has(data.parent)) {
            dataKeyMap.get(data.parent).push(data)
  
            // dataKeyMap.delete(data.parent)
          }else {
            dataKeyMap.set(data.parent, [data])
          }
        }
        
        dataKeyMap.forEach((value, key, map)=>{
          for(let data of value) {
            data.child = dataKeyMap.get(data.key) || []
          }
        })
        return dataKeyMap
      },

      async initStateCheck(){
        const { protocols } = this.PROCESS_INFO ; 
        if(!protocols){ // protocols이 세팅 완료되지 않아 null일 경우 return.
          return;
        }

        const crntProtocol = protocols.filter(o=>o.id == this.$route.query.protocolId)[0];

        if(!crntProtocol){
          this.emptyProtocol = true;
          return;
        }
        this.emptyProtocol = false;
        this.protocolType = crntProtocol.protocolType;

        // console.log( "crntProtocol", crntProtocol  )

        /** 로그 등록 */
        await this.$wApi.trace.log({
          type : 'PR', //PD 공정도, PR 프로토콜
          code : 'R', //N 생성 M 수정 S 검색 R 조회
          subCode : '01',
          keyword : '',
          result : 1,
          ptlId : crntProtocol.id
        });
        /** 로그 등록 */    

        // crntProtocol.json = await this.convertIssuesStringToJSON( crntProtocol.json ) ; 
        crntProtocol.json = typeof crntProtocol.json == 'string' ? JSON.parse(crntProtocol.json) : crntProtocol.json;
        // 현재 templete 모드 일 경우 typechecked를 tree로 설정함으로서 위키로 이동이 불가
        // 추후 확인 후 변경 필요
        // if( crntProtocol.json?.init === true ){
        //   this.treeMode = "templete";
        //   this.typeChecked = "tree";
        //   this.initChecked = true;
        // }else{
        //   // delete crntProtocol.json.init;
        //   this.initChecked = false;
        // }
      },
      async saveDiagram(releaseFlag) {
        if(this.typeChecked == 'tree'){
          await this.$refs.editor.saveHandler(releaseFlag);  
        }else if (this.typeChecked == 'wiki'){
          /*자동저장 로그 insert*/
          if (releaseFlag != true) { // 공개 팝업 open 직전 자동 저장의 경우 modify version을 상승시키지 않음. (공개 완료 후 backend에서 log insert)
              const autoSaveResPonse = await this.$wApi.protocol.autoSave.create({protocolId: this.$route.query.protocolId});
          }
          window.wToast("프로토콜 자동저장을 완료하였습니다." , {variant: "wtoast-bg",}) ; 
        }
      },
      searchProcessNode(){
        this.searchPrcessMethods.show();
      },
      getChildMethods(type,methods){
        if(type === 'search'){
          this.searchPrcessMethods = methods;
        }else if(type === 'preview'){
          this.searchPrcessPreviewMethods = methods;
        }
		  },
      searchPopupShow(){
        this.searchPrcessMethods.show(true);
      },
      selectProcess(item) {
        this.selectProcessInfo = item;
      },
      previewClick(item) {
        if(!this.selectProcessInfo) return;
        this.searchPrcessMethods.hide(true);
        this.searchPrcessPreviewMethods.show();
      },
    }
  }
  </script>
  
  <style lang="scss">
  .protocol-editor {
    display: grid;
    grid-template:
    'top top' auto
    'aside editor' 1fr /
    auto 1fr;
    position: relative;

    .process-editor-top {
      grid-area: top;
    }
    .bookmarks {
      grid-area: aside;
      width: 250px; height: 100%;
      border-right: 1px solid #999;
    
    }
    .issueList {
      // --moveWidth : var( --protocol-lnb-width ); 
      // grid-area: aside;
      // width: var( --moveWidth ); 
      padding: 16px;
      border-right: 1px solid #999;
      font-size: 14px;
      overflow-x: auto; 
      overflow-y: auto;
      @include text-prt-sb;
      @include scrlbar; 
      // transform: translateX( calc( var( --moveWidth ) * -1) ); 
      transition: transform 0.45s; 

      &.active {
        transform: translateX( 0px ); 
      }

      /* .protocolTitle {
        width: 120px; 
        height: 33px; 
        border: 2px solid $gray-9; 
        display: flex; 
        align-items: center; 
        justify-content: center; 
        border-radius: 40px; 
        color: $gray-6; 
        margin-bottom: 18px; 
      } */
  
      .processName {
        white-space: nowrap; 
        text-overflow: ellipsis; 
        min-height: 14px; 
        overflow: hidden; 
        cursor: pointer; 
        margin-bottom: 18px;
        font-size: 14px; 
        @include text-prt-sb; 
      }
      ol {
        display: flex; flex-direction: column;
        gap: 16px;
        padding-left: 34px;
        li {
          list-style: auto;
          font-size: 14px;
          @include text-prt-sb;
        }
      }
      .acodian {
        padding: 0px 16px;
        h3 {
          display: flex; align-items: center;
          &:before {
            content: '';
            display: block;
            width: 24px; height: 24px;
            background: url('../../assets/icons/accordion-more.svg') center no-repeat;
          }
          padding: 8px 0;
        }
        ol {
          margin-top: 8px;
        }
        .acodian {
          padding: 0 8px;
        }
      }
    }
    .protocolControl {
      grid-area: editor;
      position: relative;
      min-width: 0;
      overflow: hidden;
      // height: 100%;
      // overflow: auto;
  
      .tabWrap {
        display: flex; gap: 16px; align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        width: auto;

        /* 위키 모드에서도 탭은 좌측 고정 (기존 250px 이동 제거) */
        &.wikiActive {
          left: 0;
        }
        padding: 16px;
        color: #999;
        z-index: 3;   
        // backdrop-filter: blur( 2px );
        background-color: $white; 

        & > label {
          display: inline-flex; align-items: center;
          @include text-prt-sb;
          font-size: 16px;
          cursor: pointer;
          input {
            width: 0;
            visibility: hidden;
            &:checked + span {
              color: #333;
            }
          }

          &:nth-of-type(2)::before {
            display: inline-block;
            content: '';
            width: 1px; height: 16px;
            margin-right: 16px;
            background-color: #999;
          }
        }

        .docOption {
          margin: 0 0 0 auto;
        }
      }
    }
  
    .tab {
      display: flex;
      position: absolute; top: 69px; left: 206px;
      
      a {
        display: block;
        width: 100px; height: 30px;
      }
    }
  }
  
  .wikiViewerPopup {
    display: flex; align-items: center; justify-content: center;
    position: fixed; top:0; left:0; right:0; bottom:0;
    background: rgba(0,0,0, .2);
    z-index: 100;

    .layerWrap {
      display: flex; flex-direction: column;
      position: relative;
      max-width: 1600px;
      height: 90%;;
      background-color: #fff;
      > h2 {
        padding: 20px 40px;
        border-bottom: 1px solid #ddd;
        font-size: 25px;
      }
      .wikiViewerWrap {
        overflow: hidden;
      }
      .close {
        position: absolute; top: 20px; right: 30px;
        width: 24px; height: 24px;
        background: url('@/assets/icons/icon-close.svg') center no-repeat;
        background-size: 100%;
        font-size: 0;
      }
    }
  }

  /* ============================================
     프로토콜 에디터 크롬 재스킨 — 계측장비 테마
     (.protocol-editor 범위 한정. 공정도 에디터에 영향 없음)
     ============================================ */
  .protocol-editor {
    height: 100%;
    min-height: 0;
    background: #fff;

    /* 상단 헤더 (ProcessTop 오버라이드) */
    .process-editor-top {
      background: #fff !important;
      border-bottom: 1px solid #e1e5ea !important;

      .process-name {
        p {
          font-size: 15px !important;
          font-weight: 700 !important;
          color: #14171c !important;
        }

        .btn_top {
          border: 1px solid #e7e9ee !important;
          border-radius: 8px !important;
          background: #fff !important;
          color: #6b7280 !important;
          font-size: 12px !important;
          font-weight: 600 !important;

          &:hover {
            border-color: #032C7C !important;
            color: #032C7C !important;
          }
        }
      }
    }

    /* 좌측 패널 (기본값SET / 실험타입 리스트) */
    .issueListWrap,
    .issueList {
      background: #fbfcfc !important;
      border-right: 1px solid #e1e5ea !important;
    }

    /* 트리/위키 탭 */
    .protocolControl .tabWrap {
      gap: 0 !important;
      padding: 0 16px !important;
      border-bottom: 1px solid #e1e5ea;
      background-color: #fff !important;

      & > label {
        padding: 12px 14px !important;
        font-size: 13px !important;
        font-weight: 600 !important;
        letter-spacing: 0;
        color: #98a0ab;
        box-shadow: inset 0 -2px 0 transparent;
        transition: color 0.15s, box-shadow 0.15s;

        &:nth-of-type(2)::before { display: none !important; }

        input:checked + span {
          color: #032C7C !important;
        }
        &:hover span { color: #1a2236; }
      }
      & > label:has(input:checked) {
        box-shadow: inset 0 -2px 0 #032C7C;
      }
    }

    /* 위키 영역: 상단 탭 바(약 52px) 높이만큼 내려서 겹침 방지 + 내부 스크롤 */
    .protocolControl .wikiContentOverflow {
      position: relative;
      height: 100%;
      padding-top: 52px;
      box-sizing: border-box;
      background: #fff;
    }
    .protocolControl .wikiWrap {
      min-width: 0;
      height: 100%;
      overflow-y: auto;
    }
    /* 목차는 좌측 고정(스크롤 시 따라오도록) + 자체 상단 여백 축소 */
    .protocolControl .wikiWrap .protocol_detail_list_area {
      position: sticky;
      top: 0;
      align-self: flex-start;
      padding-top: 16px;
    }
    /* 본문 상단 과도한 여백 축소 (기존 100px → 40px) */
    .protocolControl .wikiWrap .contentsWrap {
      padding-top: 40px;
    }

    /* 하단 액션 바 (저장/공개/문서설정 등) */
    .optWrap {
      gap: 6px;

      button {
        border: 1px solid #e7e9ee !important;
        border-radius: 8px !important;
        background: #fff !important;
        color: #4b5260 !important;
        font-size: 12.5px !important;
        font-weight: 600 !important;
        transition: border-color 0.15s, color 0.15s, background 0.15s;

        &:hover {
          border-color: #032C7C !important;
          color: #032C7C !important;
        }
      }

      .historySave {
        border-color: #032C7C !important;
        background: #032C7C !important;
        color: #fff !important;

        &:hover {
          background: #0a3d9e !important;
          color: #fff !important;
        }
      }

      .publishWrap .publishStatus {
        font-size: 11.5px;
      }

      /* 사이드바(공정도 연결/공개 설정)로 이동한 액션은 하단 바에서 숨김.
         공개 상태 표시(.publishStatus)는 유지 */
      .connectProcess { display: none !important; }
      .publishWrap > button { display: none !important; }
    }

    /* 편집 모드 하단 바 전체를 사이드바 액션(저장/미리보기/문서설정/읽기모드)으로 대체 */
    .optWrap.protocolBtmBar { display: none !important; }

    /* 읽기모드: 작성자 권한이면 연결관리/수정모드/문서정보도 사이드바로 이동.
       권한 없는 사용자의 '활용' 버튼 바는 그대로 유지 */
    .optWrap.protocolReadBar { display: none !important; }
  }

  /* ---------- 반응형 (프로토콜 에디터 전용) ---------- */
  @media (max-width: 1024px) {
    .protocol-editor {
      grid-template:
        'top' auto
        'aside' auto
        'editor' 1fr /
        1fr;

      .issueList {
        width: 100%;
        max-height: 180px;
        border-right: 0;
        border-bottom: 1px solid #999;
      }

      .protocolControl {
        .tabWrap,
        .tabWrap.wikiActive {
          left: 0;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .protocol-editor {
      .issueList {
        max-height: 140px;
        padding: 10px 12px;
      }

      .protocolControl .tabWrap {
        gap: 10px;
        padding: 10px 12px;

        & > label {
          font-size: 14px;

          &:nth-of-type(2)::before {
            margin-right: 10px;
          }
        }
      }

      .wikiViewerPopup .layerWrap {
        width: 94vw;
        max-width: none;
        height: 94%;

        > h2 {
          padding: 14px 20px;
          font-size: 18px;
        }

        .close {
          top: 14px;
          right: 16px;
        }
      }
    }
  }
</style>
